import React, { useState, useEffect } from 'react';
import '../styles.css';
import Header from '../Components/Header';
import TopHeader from '../Components/Header/topHeader';
import { Box, Typography, Button, TextField, Snackbar, Alert } from '@mui/material';
import { useSelector } from 'react-redux';

const AccountManagement = () => {
  const [userId, setUserId] = useState(null);
  const [username, setUsername] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [fullname, setFullname] = useState('');
  const [role, setRole] = useState('');
  const [bankName, setBankName] = useState(''); // New bank_name state
  const [bankNo, setBankNo] = useState(''); // New bank_no state
  const [accountTitle, setAccountTitle] = useState(''); // New account_title state
  const [balance, setBalance] = useState(''); // New balance state
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [saveSnackbarOpen, setSaveSnackbarOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const developeruid = useSelector((state) => state.authReducer.developeruid);
  const isLang = useSelector((state) => state.authReducer.lang);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
    setSaveSnackbarOpen(false);
  };

  // Convert object to urlencoded string
  const toUrlEncoded = (obj) =>
    Object.keys(obj)
      .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
      .join('&');

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!username || !oldPassword || !newPassword) {
      setErrorMessage(isLang === 'arabic' ? 'يرجى ملء جميع الحقول المطلوبة' : 'Please fill in all required fields');
      setSnackbarOpen(true);
      return;
    }

    try {
      setLoading(true);

      const formDataToSend = {
        username: username,
        current_password: oldPassword,
        new_password: newPassword,
        fullname: fullname,
        bank_name: bankName,
        bank_no: bankNo,
        account_title: accountTitle,
        balance: balance,
      };

      console.log('Sending the following data:', formDataToSend);
      const body = toUrlEncoded(formDataToSend);
      const response = await fetch(`${apiConfig.API_URL}/aapi/developer_api/reset_password.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: body,
      });

      const result = await response.json();

      if (response.ok && result.status === 'success') {
        setSaveSnackbarOpen(true);
      } else {
        setErrorMessage(result.message || (isLang === 'arabic' ? 'فشل في تحديث الحساب' : 'Failed to update account'));
        setSnackbarOpen(true);
      }

      setLoading(false);
    } catch (error) {
      setErrorMessage(isLang === 'arabic' ? 'حدث خطأ أثناء تحديث الحساب' : 'An error occurred while updating the account');
      setSnackbarOpen(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      const storedData = JSON.parse(localStorage.getItem('userData'));
      const uid = developeruid;

      if (!uid) {
        console.error('User ID is missing from localStorage');
        return;
      }

      setUserId(uid);

      try {
        const formData = new FormData();
        formData.append('uid', uid);

        const response = await fetch(`${apiConfig.API_URL}/aapi/developer_api/getuserdata.php`, {
          method: 'POST',
          body: formData,
        });

        if (!response.ok) {
          throw new Error('Failed to fetch user data');
        }

        const data = await response.json();
        if (data.length > 0) {
          const account = data[0];
          setUsername(account.username);
          setFullname(account.fullname);
          setRole(account.role);
          setBankName(account.bank_name);
          setBankNo(account.bank_no);
          setAccountTitle(account.account_title);
          setBalance(account.balance);
        }
      } catch (error) {
        console.error('Error fetching user data:', error.message);
      }
    };

    fetchUserData();
  }, []);

  return (
    <>
      <div className="containers">
        <Header />
        <div>
          <TopHeader title={isLang === 'arabic' ? 'إدارة الحساب' : 'Account Management'} />
          <div style={{ padding: '30px 60px' }}>
            <Box sx={{ maxWidth: 600, margin: 'auto' }}>
              <Typography variant="h5" sx={{ mb: 4, textAlign: 'center' }}>
                {isLang === 'arabic' ? 'تعديل معلومات الحساب' : 'Edit Account Information'}
              </Typography>

              <form onSubmit={handleFormSubmit}>
                <TextField
                  label={isLang === 'arabic' ? 'اسم المستخدم' : 'Username'}
                  fullWidth
                  disabled
                  sx={{ mt: 2 }}
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />

                <TextField
                  label={isLang === 'arabic' ? 'كلمة المرور القديمة' : 'Old Password'}
                  fullWidth
                  sx={{ mt: 2 }}
                  type="password"
                  value={oldPassword}
                  placeholder={isLang === 'arabic' ? 'أدخل كلمة المرور القديمة' : 'Enter Old password'}
                  onChange={(e) => setOldPassword(e.target.value)}
                />

                <TextField
                  label={isLang === 'arabic' ? 'كلمة المرور الجديدة' : 'New Password'}
                  fullWidth
                  sx={{ mt: 2 }}
                  type="password"
                  value={newPassword}
                  placeholder={isLang === 'arabic' ? 'أدخل كلمة مرور جديدة' : 'Enter a new password'}
                  onChange={(e) => setNewPassword(e.target.value)}
                />

                <TextField
                  label={isLang === 'arabic' ? 'الاسم الكامل' : 'Full Name'}
                  fullWidth
                  sx={{ mt: 2 }}
                  value={fullname}
                  onChange={(e) => setFullname(e.target.value)}
                />

                <TextField
                  label={isLang === 'arabic' ? 'الدور' : 'Role'}
                  fullWidth
                  sx={{ mt: 2 }}
                  value={role}
                  disabled
                />

                <TextField
                  label={isLang === 'arabic' ? 'اسم البنك' : 'Bank Name'}
                  fullWidth
                  sx={{ mt: 2 }}
                  value={bankName}
                  onChange={(e) => setBankName(e.target.value)}
                />

                <TextField
                  label={isLang === 'arabic' ? 'رقم البنك' : 'Bank Number'}
                  fullWidth
                  sx={{ mt: 2 }}
                  value={bankNo}
                  onChange={(e) => setBankNo(e.target.value)}
                />

                <TextField
                  label={isLang === 'arabic' ? 'عنوان الحساب' : 'Account Title'}
                  fullWidth
                  sx={{ mt: 2 }}
                  value={accountTitle}
                  onChange={(e) => setAccountTitle(e.target.value)}
                />

                <Button variant="contained" type="submit" sx={{ mt: 4, width: '100%' }}>
                  {isLang === 'arabic' ? 'حفظ التغييرات' : 'Save Changes'}
                </Button>
              </form>
              {loading && <div className="loader"></div>}
            </Box>
          </div>
        </div>
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity="error">
          {errorMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        open={saveSnackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity="success">
          {isLang === 'arabic' ? 'تم تحديث الحساب بنجاح!' : 'Account updated successfully!'}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AccountManagement;
